<template>
  <base-section id="non-financial-report" class="grey lighten-4">
    <base-section-heading color="grey lighten-2" title="Laporan Non Keuangan" />

    <v-container>
      <v-tabs background-color="secondary">
        <v-tab href="#gcg">Laporan Tata Kelola (GCG)</v-tab>
        <!-- <v-tab href="#pedoman">Pedoman</v-tab> -->
        <v-tab-item value="gcg">
          <v-card flat>
            <v-card-text>
              <v-list-item
                v-for="card in report_gcg"
                :key="card.web_report_name"
                @click="Open(card.web_report_path_url)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><v-icon>mdi-file-pdf-box</v-icon
                    >{{ card.web_report_name }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="pedoman">
          <v-card flat>
            <v-card-text>
              <v-list-item
                v-for="card in report_pd"
                :key="card.web_report_name"
                @click="Open(card.web_report_path_url)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><v-icon>mdi-file-pdf-box</v-icon
                    >{{ card.web_report_name }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item></v-card-text
            >
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionFinancialReport",
  data: () => ({
    report_gcg: [],
    report_pd: []
  }),
  created() {
    this.Report("GCG");
    this.Report("PD");
  },
  methods: {
    Report(category) {
      let formdata = {
        web_report_category: category,
        order_by: "web_report_year",
        order_type: "DESC"
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebReportList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          let data = response.data;
          if (data.length > 0) {
            if (data[0].feedback === "Y") {
              if (category === "GCG") {
                this.report_gcg = data;
              } else if (category === "PD") {
                this.report_pd = data;
              }
            } else {
              this.snackbar.value = true;
              this.snackbar.text = data[0].feedback;
            }
          } else {
            if (category === "GCG") {
              this.report_gcg = [];
            } else if (category === "PD") {
              this.report_pd = [];
            }
          }
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
        });
    },
    Open(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
